import queryString from "query-string";
import Cards from "react-credit-cards";
import { useForm } from "react-hook-form";
import Modal from "react-bootstrap/Modal";
import { useLocation } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import base_url from "../../api/bootapi";

const IMEIReactivationForm = ({ type }) => {
  const { search } = useLocation();
  const queryparam = queryString.parse(search);

  const [message, setmessage] = useState();
  const [error, seterror] = useState(false);
  const [loader, setloader] = useState(false);
  const [success, setsuccess] = useState(false);
  const [showcard, setshowcard] = useState(false);
  const [terminatemodal, setterminatemodal] = useState(false);
  const [showsuccessmodal, setshowsuccessmodal] = useState(false);
  const [cvc, setcvc] = useState("");
  const [focus, setfocus] = useState();
  const [expiry, setexpiry] = useState("");
  const [cardyear, setcardyear] = useState("");
  const [cardmonth, setcardmonth] = useState("");
  const [datearray, setdatearray] = useState([]);
  const [montharray, setmontharray] = useState([]);
  const [newcardnumber, setnewcardnumber] = useState("");
  const [cardholdername, setcardholdername] = useState("");

  useEffect(() => {
    if (type === "pay") {
      setshowcard(true);
    } else {
      setshowcard(false);
    }
  }, [type]);

  const messagesEndRef = useRef(null);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "all",
  });

  useEffect(() => {
    addyears();
  }, []);

  const addyears = () => {
    let date2 = new Date();
    let arr = [date2.getFullYear()];
    for (let i = 1; i <= 16; i++) {
      let date = new Date();
      let adddata = date.getFullYear() + i;
      arr.push(adddata);
    }
    let month = Array.from(Array(12), (val, index) => index + 1);
    month.forEach((item) => {
      let appendedvalue = String(item).padStart(2, "0");
      setmontharray((prev) => [...prev, appendedvalue]);
    });
    setdatearray(arr);
  };

  const onyearChange = (e) => {
    setmontharray([]);
    if (Number(e.target.value) === Number(new Date().getFullYear())) {
      let monthnumber = new Date().getMonth();
      let month = Array.from(
        Array(12 - monthnumber),
        (val, index) => monthnumber + index + 1
      );
      month.forEach((item) => {
        let appendedvalue = String(item).padStart(2, "0");
        setmontharray((prev) => [...prev, appendedvalue]);
      });
      if (Number(cardmonth) < Number(monthnumber + 1)) {
        setcardmonth("");
      }
    } else {
      let month = Array.from(Array(12), (val, index) => index + 1);
      month.forEach((item) => {
        let appendedvalue = String(item).padStart(2, "0");
        setmontharray((prev) => [...prev, appendedvalue]);
      });
    }
  };

  const reactivatedevice = (data2) => {
    if (showcard && !cardmonth) {
      return;
    }
    if (showcard) {
      setloader(true);
      let data = {
        credit_card: {
          cardholder_name: data2.cardholderName,
          cvv: data2.cvc,
          expiration_date: `${cardmonth}/${cardyear}`,
          number: data2.cardNumber,
        },
        customer_id: queryparam?.customer_id,
        imei: queryparam?.imei,
        iccid: queryparam?.iccid,
        email: queryparam?.email,
        paying: true,
      };
      calldormentapi(data);
    } else if (queryparam?.paying === "yes") {
      setloader(true);
      let data = {
        customer_id: queryparam?.customer_id,
        imei: queryparam?.imei,
        iccid: queryparam?.iccid,
        email: queryparam?.email,
        paying: true,
      };
      calldormentapi(data);
    } else if (queryparam?.paying === "no") {
      setterminatemodal(true);
    }
  };
  const handleterminate = () => {
    setterminatemodal(false);
    setloader(true);
    let data = {
      customer_id: queryparam?.customer_id,
      imei: queryparam?.imei,
      iccid: queryparam?.iccid,
      email: queryparam?.email,
      paying: false,
    };
    calldormentapi(data);
  };

  const calldormentapi = (data) => {
    axios
      .post(`${base_url}/auth/dormant-fees`, data)
      .then((res) => {
        setloader(false);
        if (res.data.status) {
          setsuccess(true);
          setshowsuccessmodal(true);
          seterror(false);
        } else {
          let error = res.data.message;
          if (res.data.error) error = error + " : " + res.data.error;
          setmessage(error);
          setsuccess(false);
          seterror(true);
          setloader(false);
          scrollToBottom();
        }
      })
      .catch((err) => {
        if (err.response) {
          let error = err.response.data?.message;
          if (err.response.data?.error) {
            error = error + " : " + err.response.data?.error;
          }
          setmessage(error);
        } else {
          setmessage("Something Went Wrong");
        }
        setsuccess(false);
        seterror(true);
        setloader(false);
        scrollToBottom();
      });
  };
  const handleCloseModal = () => {
    setshowsuccessmodal(false);
    setsuccess(true);
    scrollToBottom();
  };

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <form id="myForm" onSubmit={handleSubmit(reactivatedevice)}>
      <div>
        <h4 className="cancellationobd_h4">Activating Dormant Mode</h4>
      </div>
      {loader ? (
        <img width={300} alt="loader" src="./loading.gif" />
      ) : (
        <>
          {queryparam?.customer_id && (
            <>
              <div className="form-group">
                <div className="row text-left form-group">
                  <div className="col-md-5 reactivationobd_font">Email :</div>
                  <div className="col-md-7 reactivationobd_font">
                    {queryparam?.email}
                  </div>
                </div>
                <div className="row text-left form-group">
                  <div className="col-md-5 reactivationobd_font">
                    Customer ID :
                  </div>
                  <div className="col-md-7 reactivationobd_font">
                    {queryparam?.customer_id}
                  </div>
                </div>
                <div className="row text-left ">
                  <div className="col-md-5 reactivationobd_font">
                    IMEI NUMBER :
                  </div>
                  <div className="col-md-7 reactivationobd_font">
                    {queryparam?.imei}
                  </div>
                </div>
                <div className="row text-left ">
                  <div className="col-md-5 reactivationobd_font">ICCID :</div>
                  <div className="col-md-7 reactivationobd_font">
                    {queryparam?.iccid}
                  </div>
                </div>
                {showcard && (
                  <div className="row text-left ">
                    <div className="col-md-5 reactivationobd_font">Cost :</div>
                    <div className="col-md-7 reactivationobd_font">$1</div>
                  </div>
                )}
                <div>
                  <p className="text-danger text-left">
                    Note : Its not mandatory to pay $1 to keep dormant mode. But
                    we wanted to let you know that sim company charges us. Even
                    if you dont pay, we will keep the sim in dormant mode and
                    company will bear the cost.
                  </p>
                </div>
              </div>
              {success ? (
                <div></div>
              ) : (
                <>
                  {queryparam?.paying === "no" && (
                    <div>
                      <div className="alert alert-danger">
                        <strong>
                          Note : Once Terminated device will never be activated
                          in future{" "}
                        </strong>
                      </div>
                    </div>
                  )}
                </>
              )}
              {showcard && (
                <div className="form-group">
                  <Cards
                    number={newcardnumber}
                    name={cardholdername}
                    expiry={expiry}
                    cvc={cvc}
                    focused={focus}
                  />
                </div>
              )}
              {showcard && (
                <div className="form-group">
                  <div className="row">
                    <div className="col-md-12">
                      <input
                        {...register("cardholderName", { required: true })}
                        className="form-control"
                        placeholder="Card Holder Name"
                        onChange={(e) => setcardholdername(e.target.value)}
                        onFocus={(e) => setfocus(e.target.name)}
                      />
                      {errors.cardholderName && (
                        <span className="errormessage">
                          <span>
                            <i
                              className="fa fa-times errorifont"
                              aria-hidden="true"
                            ></i>
                          </span>
                          Card Holder Name is required
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              )}
              {showcard && (
                <div className="form-group">
                  <div className="row">
                    <div className="col-md-9">
                      <input
                        {...register("cardNumber", {
                          required: true,
                          maxLength: 20,
                          minLength: 15,
                        })}
                        type="number"
                        onWheel={(event) => event.currentTarget.blur()}
                        className="form-control"
                        placeholder="Card Number"
                        onChange={(e) => setnewcardnumber(e.target.value)}
                        onFocus={(e) => setfocus(e.target.name)}
                      />
                      {errors.cardNumber?.type === "required" && (
                        <span className="errormessage">
                          <span>
                            <i
                              className="fa fa-times errorifont"
                              aria-hidden="true"
                            ></i>
                          </span>
                          CardNumber is required
                        </span>
                      )}
                      {errors.cardNumber?.type === "minLength" && (
                        <span className="errormessage">
                          <span>
                            <i
                              className="fa fa-times errorifont"
                              aria-hidden="true"
                            ></i>
                          </span>
                          CardNumber should be minimum of 15 numbers
                        </span>
                      )}
                      {errors.cardNumber?.type === "maxLength" && (
                        <span
                          className="errormessage"
                          style={{ fontSize: "15px" }}
                        >
                          <span>
                            <i
                              className="fa fa-times errorifont"
                              aria-hidden="true"
                            ></i>
                          </span>
                          CardNumber cannot exceed more than 20 numbers
                        </span>
                      )}
                    </div>
                    <div className="col-md-3">
                      <input
                        {...register("cvc", {
                          required: true,
                          minLength: 3,
                          maxLength: 4,
                        })}
                        type="number"
                        onWheel={(event) => event.currentTarget.blur()}
                        className="form-control"
                        placeholder="CVV"
                        onChange={(e) => setcvc(e.target.value)}
                        onFocus={(e) => setfocus(e.target.name)}
                      />
                      {errors.cvc?.type === "required" && (
                        <span
                          className="errormessage text-left"
                          style={{ fontSize: "14px" }}
                        >
                          <span>
                            <i
                              className="fa fa-times errorifont"
                              aria-hidden="true"
                            ></i>
                          </span>
                          CVV is required
                        </span>
                      )}
                      {errors.cvc?.type === "minLength" && (
                        <span
                          className="errormessage"
                          style={{ fontSize: "14px" }}
                        >
                          <span>
                            <i
                              className="fa fa-times errorifont"
                              aria-hidden="true"
                            ></i>
                          </span>
                          CVV should be minimum of 3 numbers
                        </span>
                      )}
                      {errors.cvc?.type === "maxLength" && (
                        <span
                          className="errormessage"
                          style={{ fontSize: "14px" }}
                        >
                          <span>
                            <i
                              className="fa fa-times errorifont"
                              aria-hidden="true"
                            ></i>
                          </span>
                          CVV cannot be more than 4 numbers
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              )}
              {showcard && (
                <div className="form-group">
                  <div className="row">
                    <div className="col-md-6">
                      <select
                        {...register("expirationdatemonth", { required: true })}
                        value={cardmonth}
                        onChange={(e) => {
                          setcardmonth(e.target.value);
                          setexpiry(`${e.target.value}/${cardyear}`);
                        }}
                        onFocus={(e) => setfocus(e.target.value)}
                        className="form-control"
                      >
                        <option value="">MM</option>
                        {montharray?.map((item, index) => (
                          <option key={index + 1} value={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                      {errors.expirationdatemonth && (
                        <span className="errormessage">
                          <span>
                            <i
                              className="fa fa-times errorifont"
                              aria-hidden="true"
                            ></i>
                          </span>
                          Month is required
                        </span>
                      )}
                    </div>
                    <div className="col-md-6">
                      <select
                        {...register("expirationdateyear", { required: true })}
                        value={cardyear}
                        onChange={(e) => {
                          setcardyear(e.target.value);
                          onyearChange(e);
                          setexpiry(`${cardmonth}/${e.target.value}`);
                        }}
                        className="form-control"
                        onFocus={(e) => setfocus(e.target.value)}
                      >
                        <option value="">YYYY</option>
                        {datearray?.map((item, index) => (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                      {errors.expirationdateyear && (
                        <span className="errormessage">
                          <span>
                            <i
                              className="fa fa-times errorifont"
                              aria-hidden="true"
                            ></i>
                          </span>
                          Year is required
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              )}
              {error ? (
                <div>
                  <div className="alert alert-danger">
                    <strong>Error! </strong>
                    {message}
                  </div>
                </div>
              ) : null}
              <div ref={messagesEndRef} />
              {success ? (
                <div>
                  <div className="alert alert-success">
                    <strong>Success! </strong>
                    {queryparam?.paying === "yes"
                      ? "Dormant SIM subscription activated"
                      : "Sim Terminated Successfully"}
                  </div>
                </div>
              ) : (
                <div
                  className="activation"
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div></div>
                  <button className={"btn btn-primary"} type="submit">
                    {queryparam?.paying === "no" ? "Terminate" : "Update"}
                  </button>
                </div>
              )}

              <Modal
                size="md"
                show={showsuccessmodal}
                onHide={() => handleCloseModal()}
                backdrop="static"
              >
                <Modal.Header closeButton={() => handleCloseModal()}>
                  <Modal.Title style={{ color: "#3947e6" }}>
                    Success!!
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <h4 className="form-main" style={{ color: "#3947e6" }}>
                    {queryparam?.paying === "yes"
                      ? "Activated Dormant Mode Successfully"
                      : "Dormant Mode Terminated Successfully"}
                  </h4>
                </Modal.Body>
                <Modal.Footer>
                  <button
                    onClick={() => handleCloseModal()}
                    type="button"
                    className="btn btn-primary"
                  >
                    Ok
                  </button>
                </Modal.Footer>
              </Modal>
              {/* Terminate Modal */}
              <Modal
                size="md"
                show={terminatemodal}
                onHide={() => setterminatemodal(false)}
                backdrop="static"
              >
                <Modal.Header closeButton={() => setterminatemodal(false)}>
                  <Modal.Title style={{ color: "#3947e6" }}>
                    Confirmation
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <h4 className="form-main" style={{ color: "#3947e6" }}>
                    Are you sure you want to terminate sim ?
                  </h4>
                  <div>
                    <div className="alert alert-danger">
                      <strong>
                        Note : This action permanently removes the SIM from
                        service. The SIM will no longer connect to the network
                        once Terminated. This action cannot be reversed.
                      </strong>
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <div className="d-flex justify-content-end">
                    <button
                      onClick={() => setterminatemodal(false)}
                      type="button"
                      className="btn btn-danger mr-2"
                    >
                      No
                    </button>
                    <button
                      onClick={() => handleterminate()}
                      type="button"
                      className="btn btn-primary"
                    >
                      Yes
                    </button>
                  </div>
                </Modal.Footer>
              </Modal>
            </>
          )}
        </>
      )}
    </form>
  );
};

export default IMEIReactivationForm;
